import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/HomePage/Home';

import NotFound404 from './pages/NotFound404';
import BalingPage from './pages/BalingPage/BalingPage';
import UIUCPage from './pages/UIUCPage/UIUCPage';

const RouterConfig: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="*" element={<NotFound404 />} />
      <Route path="/balingPage" element={<BalingPage />} />
      <Route path="/uiucPage" element={<UIUCPage />} />
      <Route path="/internshipPage" element={<NotFound404 />} />
      <Route path="/musicPage" element={<NotFound404 />} />
    </Routes>
  );
};

export default RouterConfig;
